module.exports = __webpack_public_path__ + "img/header-timer.541f4358.png";